import {FC, useState} from "react";

import ReactJsonView from "@microlink/react-json-view";
import {Copy, Expand, Minus, Plus} from "lucide-react";

import {Button} from "@/components/ui/Button";
import JsonViewDialog, {
  JSON_VIEWER_THEME,
} from "@/components/ui/JsonViewDialog";
import {useToast} from "@/hooks/useToast";

const JsonContainer: FC<{
  data: object;
  collapsed?: boolean | number;
  style?: React.CSSProperties;
}> = ({data, collapsed = false, style}) => {
  const {successToast} = useToast();
  const [isCollapsed, setIsCollapsed] = useState<boolean | number>(collapsed);
  const handleCopy = () => {
    navigator.clipboard.writeText(JSON.stringify(data, null, 2));
    successToast("Copied to clipboard");
  };

  return (
    <div
      style={{
        position: "relative",
        borderRadius: 6,
        padding: "10px 20px",
        backgroundColor: "#171717",
        ...style,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          display: "flex",
          gap: 4,
          zIndex: 1,
        }}
      >
        <Button
          variant="ghost"
          size="icon"
          title={isCollapsed ? "Expand" : "Collapse"}
          className="w-6 h-6"
          onClick={() => setIsCollapsed(prev => !prev)}
          style={{
            color: "#78cdbd",
          }}
        >
          {isCollapsed ? (
            <Plus className="pointer-events-none" />
          ) : (
            <Minus className="pointer-events-none" />
          )}
        </Button>
        <Button
          variant="ghost"
          size="icon"
          onClick={handleCopy}
          title="Copy JSON"
          className="w-6 h-6"
          style={{
            color: "#78cdbd",
          }}
        >
          <Copy className="pointer-events-none" />
        </Button>
        <JsonViewDialog
          data={data}
          trigger={
            <Button
              variant="ghost"
              size="icon"
              title="Expand"
              className="w-6 h-6"
              style={{
                color: "#78cdbd",
              }}
            >
              <Expand className="pointer-events-none" />
            </Button>
          }
        />
      </div>

      <ReactJsonView
        name={null}
        src={data}
        enableClipboard={false}
        displayObjectSize={false}
        collapsed={isCollapsed}
        displayDataTypes={false}
        theme={JSON_VIEWER_THEME}
        style={{backgroundColor: "transparent", wordBreak: "break-all"}}
      />
    </div>
  );
};

export default JsonContainer;
